import type { JSX } from '@builder.io/qwik';
import { component$, useContext } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { NavContext } from '~/contexts/NavContext';
import { AppDataContext } from '~/contexts/AppDataContext';
import NavItemDropdownLink from '~/components/Layout/Header/Desktop/NavItemDropdownLink';
import NavItemDropdownHover from '~/components/Layout/Header/Desktop/NavItemDropdownHover';
import NavItemDropdownClick from '~/components/Layout/Header/Desktop/NavItemDropdownClick';
import type { NavItemType } from '~/types/NavItemType';

const navItemClasses = cva('list-none h-full flex align-center', {
  variants: {
    level: {
      0: '',
      1: '',
    },
    navInMobile: {
      true: '',
      false: '[&>ul]:hover:grid',
    },
  },
  compoundVariants: [
    {
      level: 0,
      navInMobile: false,
      class: 'group/topnav',
    },
    {
      level: 1,
      navInMobile: false,
      class: 'relative group/dropdown',
    },
  ],
});

export default component$(
  ({ item, activeItem, level }: NavItemType): JSX.Element => {
    const appData = useContext(AppDataContext);
    const { navInMobile } = useContext(NavContext);
    const clampedLevel = level >= 1 ? 1 : 0;

    const itemKey = item.link.text + item.link.url;
    const navInMobileAndMobile =
      !!appData.payloadToSSR.isMobileViewer && !!navInMobile;
    const isActive = navInMobileAndMobile && activeItem.value === itemKey;

    return (
      <li
        class={navItemClasses({
          level: clampedLevel,
          navInMobile: navInMobileAndMobile,
        })}
      >
        <NavItemDropdownLink
          item={item}
          activeItem={activeItem}
          level={level}
        />
        {isActive && (
          <NavItemDropdownClick
            item={item}
            activeItem={activeItem}
            level={level}
          />
        )}
        {!isActive && (
          <NavItemDropdownHover
            item={item}
            activeItem={activeItem}
            level={level}
          />
        )}
      </li>
    );
  }
);
